import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const activities = [
  {
    id: 1,
    title: "Art & Drawing",
    image:
      "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497422/3_r6gwvw.png",
    accentColor: "text-pink-600",
    borderColor: "border-pink-100",
    bgColor: "bg-pink-50",
  },
  {
    id: 2,
    title: "Color Management",
    image:
      "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497417/4_pfqcxx.png",
    accentColor: "text-amber-600",
    borderColor: "border-amber-100",
    bgColor: "bg-amber-50",
  },
  {
    id: 3,
    title: "Athletic & Dance",
    image:
      "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497415/2_yzlap4.png",
    accentColor: "text-blue-600",
    borderColor: "border-blue-100",
    bgColor: "bg-blue-50",
  },
  {
    id: 4,
    title: "Language & Speaking",
    image:
      "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497420/6_rg41hy.png",
    accentColor: "text-green-600",
    borderColor: "border-green-100",
    bgColor: "bg-green-50",
  },
  {
    id: 5,
    title: "Religion & History",
    image:
      "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497425/5_vyh7ig.png",
    accentColor: "text-purple-600",
    borderColor: "border-purple-100",
    bgColor: "bg-purple-50",
  },
  {
    id: 6,
    title: "General Knowledge",
    image:
      "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497414/1_zxnhh1.png",
    accentColor: "text-cyan-600",
    borderColor: "border-cyan-100",
    bgColor: "bg-cyan-50",
  },
];

const ActivityCard = ({ activity, index }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: "-50px 0px",
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group"
    >
      <div
        className={`rounded-2xl overflow-hidden border-2 ${activity.borderColor}
        transition-all duration-500 group-hover:shadow-2xl group-hover:-translate-y-2
        h-full flex flex-col bg-white relative`}
      >
        {/* Corner highlight */}
        <div
          className={`absolute top-0 right-0 w-16 h-16 ${activity.bgColor} rounded-bl-full 
          opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
        ></div>

        {/* IMAGE (badge removed) */}
        <div className="relative overflow-hidden h-48">
          <img
            src={activity.image}
            alt={activity.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
        </div>

        {/* CONTENT */}
        <div className="p-6 flex flex-col flex-grow">
          <button
            className={`w-full py-2.5 rounded-lg font-medium transition-all duration-300 transform 
            hover:scale-[1.02] active:scale-[0.98] border-2 ${activity.borderColor} ${activity.accentColor} 
            hover:${activity.bgColor} hover:shadow-md`}
          >
            {activity.title}
          </button>
        </div>

        <div
          className={`h-1 w-full ${activity.bgColor} opacity-0 group-hover:opacity-100 
          transition-opacity duration-500`}
        ></div>
      </div>
    </motion.div>
  );
};

const Activities = () => {
  return (
    <section
      className="relative w-screen left-1/2 right-1/2 mx-[-50vw] overflow-hidden 
      -mt-12 md:-mt-16 lg:-mt-20 mb-[-48px] md:mb-[-64px] lg:mb-[-80px] 
      pt-16 md:pt-20 lg:pt-24 pb-16 md:pb-20 lg:pb-24 
      bg-gradient-to-b from-amber-50 via-[#fef9c3] to-amber-50"
      aria-labelledby="activities-heading"
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16 lg:mb-20"
        >
          <h2
            id="activities-heading"
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
          >
            Young Thinkers' <span className="text-amber-600">Arena</span>
          </h2>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Engaging activities designed for little adventurers to explore,
            express, and excel.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {activities.map((activity, index) => (
            <ActivityCard key={activity.id} activity={activity} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Activities;
